import React, { Component } from 'react';
import { connect } from 'react-redux';
import './App.css';
import ProtectedRoute from './components/Protected/ProtectedRoute';
import pckjson from '../package.json';

const mapStateToProps = state => ({
  app: state.app
})


class ConnectedApp extends Component {
  render() {
    console.log('vesrion: ', pckjson.version);
    return (
      <div className="App">
        <ProtectedRoute />
      </div>
    );
  }
}

const App = connect(mapStateToProps)(ConnectedApp);
export default App;



// WEBPACK FOOTER //
// ./src/App.js